import React from 'react';
import { Link } from '@zola/zola-ui';
import OtherThingsToReview from './OtherThingsToReview';
import './TipsModals.less';

function EtiquetteTips() {
  return (
    <div className="etiquette-tip-modal">
      <div className="tip-content-container">
        {/* <div className="modal-header">
          <span className="tip-header">Etiquette Tips</span>
        </div> */}
        <div className="modal-body">
          <h3>How To Address Wedding Invitations</h3>
          <div className="section">
            <p className="desc">
              The rules surrounding proper addressing etiquette can make your head spin... we feel
              you. But that’s why we’re here. Ensure your wedding invitations make a favorable first
              impression by following our handy addressing etiquette chart. Is your situation not
              addressed here? Head on over to our{' '}
              <Link inline href="/blog/wedding-planning/how-to-address-wedding-invitations/">
                blog
              </Link>{' '}
              to find out how to handle every addressing scenario possible.
            </p>
            <ul className="desc">
              <li>Unmarried Couple, Living Together: Ms. Rachel Green and Mr. Ross Geller</li>
              <li>Unmarried Couple, Living Separately: Send separate invitations</li>
              <li>
                Married, Same Last Name: Mr. and Mrs. Robert Belcher —or— Mr. Robert Belcher and
                Mrs. Linda Belcher
              </li>
              <li>Married, Different Last Name: Mrs. Leslie Knope and Mr. Ben Wyatt</li>
              <li>Married, Hyphenated Name: Mrs. Leslie Knope and Mr. Ben Wyatt</li>
              <li>Married, Hyphenated Name: Mr. Andy Dwyer and Ms. April Ludgate-Dwyer</li>
              <li>
                A Female Doctor & A Male Non-Doctor, Same Last Name: Doctor Rainbow and Mr. Andre
                Johnson, Sr.
              </li>
              <li>
                Two Doctors With Different Last Names: Doctor Meredith Grey and Doctor Derek
                Shepherd
              </li>
              <li>
                A Distinguished Title: The Honorable Ruth Bader Ginsberg and Mr. Martin David
                Ginsburg
              </li>
              <li>
                A Family: The Simpsons —or— Mr. and Mrs. Homer Simpson, Bart Simpson, Miss Lisa
                Simpson
              </li>
            </ul>
            {/* <table className="table table-striped">
              <thead>
                <tr>
                  <th>Who’s Invited?</th>
                  <th>How To Address Them</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Unmarried Couple, Living Together</td>
                  <td>Ms. Rachel Green and Mr. Ross Geller</td>
                </tr>
                <tr>
                  <td>Unmarried Couple, Living Separately</td>
                  <td>Send separate invitations</td>
                </tr>
                <tr>
                  <td>Married, Same Last Name</td>
                  <td>Mr. and Mrs. Robert Belcher
                    <br />
                    —or—
                    <br />
                    Mr. Robert Belcher and Mrs. Linda Belcher
                    <br />
                    —or—
                    <br />
                    Mr. Robert and Mrs. Linda Belcher
                  </td>
                </tr>
                <tr>
                  <td>Married, Different Last Name</td>
                  <td>Mrs. Leslie Knope and Mr. Ben Wyatt</td>
                </tr>
                <tr>
                  <td>Married, Hyphenated Name</td>
                  <td>Mr. Andy Dwyer and Ms. April Ludgate-Dwyer</td>
                </tr>
                <tr>
                  <td>A Female Doctor & A Male Non-Doctor, Same Last Name</td>
                  <td>Doctor Rainbow and Mr. Andre Johnson, Sr.</td>
                </tr>
                <tr>
                  <td>Two Doctors With Different Last Names</td>
                  <td>Doctor Meredith Grey and Doctor Derek Shepherd</td>
                </tr>
                <tr>
                  <td>A Distinguished Title</td>
                  <td>The Honorable Ruth Bader Ginsberg and Mr. Martin David Ginsburg</td>
                </tr>
                <tr>
                  <td>A Family</td>
                  <td>The Simpsons
                    <br />
                    —or—
                    <br />
                    Mr. and Mrs. Homer Simpson
                    Bart Simpson
                    Miss Lisa Simpson
                  </td>
                </tr>
              </tbody>
            </table> */}
          </div>
        </div>
      </div>
      <OtherThingsToReview />
    </div>
  );
}

export default EtiquetteTips;



// WEBPACK FOOTER //
// ./src/cards/components/common/modals/TipsModals/TipsEtiquette.jsx